import { useEffect, useState } from "react";

export type TocItem = {
  id: string;
  label: string;
};

type TableOfContentsProps = {
  items: TocItem[];
};

export default function TableOfContents({ items }: TableOfContentsProps) {
  const [active, setActive] = useState(items[0]?.id ?? "");
  const key = items.map((item) => item.id).join(",");

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { rootMargin: "-25% 0px -65% 0px", threshold: 0 },
    );
    key.split(",").forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [key]);

  if (items.length === 0) return null;

  return (
    <nav aria-label="本篇目录" className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="font-heading text-sm font-semibold text-foreground-950">本篇目录</h2>
      <ul className="mt-4 space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`block rounded-md border-l-2 px-3 py-2 text-sm transition-colors ${
                active === item.id
                  ? "border-primary-500 bg-primary-50 font-medium text-primary-800"
                  : "border-background-200 text-foreground-600 hover:border-primary-300 hover:text-foreground-900"
              }`}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}